import { api } from "./apiClient";

export interface ClabeListadoItem {
  clabe: string;
  claveRastreo: string;
  nombreBeneficiario: string;
  referenciaNumerica: string;
  solicitudId: string;
  montoAutorizado: number;
  montoTransferencia: number;
}

export const clabesService = {
  getSolicitudes: (ownerId: string) => 
    api.get<any[]>(`/clabes/solicitudes?ownerID=${ownerId}`),
  
  getListado: (ownerId: string) => 
    api.get<ClabeListadoItem[]>(`/clabes/listado?ownerID=${ownerId}`),
  
  validarClabe: (solicitudId: string, validado: boolean, ownerId: string, userName: string) =>
    api.post(`/clabes/validar?solicitudId=${solicitudId}&validado=${validado}&ownerID=${ownerId}&userName=${encodeURIComponent(userName)}`, {}),
};
